import { Injectable } from '@angular/core';
import { ModalService } from '../modules/modal';
import { ConfirmationModalFormComponent } from '../components/confirmation-modal-form/confirmation-modal-form.component';
import { ConfirmationFormData } from '../models/confirmation-form-data';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationModalService {

  constructor(protected modalService: ModalService) { }

  public confirmModal(modalData: ConfirmationFormData, cb: Function) {
    
    this.modalService.openModal({
      component: ConfirmationModalFormComponent,
      data: modalData,
      success: () => {
        
        cb.call(this);
      },
    });
  }

}
